const pages = [
  { name: "Community", url: "/community" },
  {
    name: "Research Programs",
    submenu: [
      { name: "DN Research Program", url: "/programs/research" },
      { name: "Panel Program", url: "/programs/panel" },
    ],
  },
  {
    name: "Resources",
    submenu: [
      { name: "Reports", url: "/resources/reports" },
      { name: "Pulse Report", url: "/developer-reports" },
      { name: "Knowledge Hub", url: "/resources/knowledge" },
      { name: "Podcast", url: "/podcast" },
    ],
  },
  {
    name: "Partner Network",
    submenu: [
      { name: "Referrers", url: "/survey/referrer" },
      { name: "Partners", url: "/survey/partner" },
      { name: "Affiliates", url: "/survey/affiliate" },
    ],
  },
  { name: "Blog", url: "/blog" },
  { name: "Forum", url: "https://forum.developernation.net/" },
];

export default pages;
